import { Skeleton, Stack } from '@mui/material';
import React from 'react';

function CustomSkeleton({ numberOfSkeleton = 4 }) {
  const spread = 100 / numberOfSkeleton - 1;
  return (
    <Stack direction={'column'} gap={2} display={'flex'} width={'100%'} height={'100%'}>
      {Array.from({ length: numberOfSkeleton }).map((_, index) => (
        <Skeleton
          key={`${index +1}`}
          data-testid="skeleton-item" // Added for testing
          active
          width={'100%'}
          height={`${spread}%`}
        />
      ))}
    </Stack>
  );
}

export default CustomSkeleton;
